<template>
    <i class="svg-icon" :style="`width:${size}px`" v-html="require(`@/assets/svg/icon-${icon}.svg`)"></i>
</template>

<script>
    export default {
        name: 'SvgIcon',
        props: {
            icon: {
                type: String,
                required: true
            },
            size: {
                type: Number,
                default: 20,
                required: true
            }
        }
    }
</script>
